<style scoped>
.window {
    border-radius: 3px;
    background: #222;
    color: #fff;
    overflow: hidden;
    position: relative;
    /* margin: 0 auto; */
    /* width: 70%; */
    
    &:before {
      content: ' ';
      display: block;
      height: 48px;
      background: #C6C6C6;
    }
    
    &:after {
      content: '. . .';
      position: absolute;
      left: 12px;
      right: 0;
      top: -3px;
      font-family: "Times New Roman", Times, serif;
      font-size: 96px;
      color: #fff;
      line-height: 0;
      letter-spacing: -12px;
    }
  }
  
  .terminal {
    margin: 20px;
    font-family: monospace;
    font-size: 16px;
    color: #22da26;
    
    .command { 
      width: 0%;
      white-space: nowrap;
      overflow: hidden;
      animation: write-command 5s both;
      
      &:before {
        content: '$ ';
        color: #22da26;
      }
    }
    
    .log {
      white-space: nowrap;
      overflow: hidden;
      animation: write-log 5s both;
    }
  
    p:nth-child(2) {
      animation-delay: 2s;
    }
    
    p:nth-child(3) {
      animation-delay: 8s;
    }
  }
  
  @keyframes write-command {
    0% {
      width: 0%;
    }
    
    
    100% {
      width: 100%;
    }
  }
  
  @keyframes write-log {
    0% {
      height: 0;
    }
    
    16% {
      height: 0;
    }
    
    17% {
      height: 18px;
    }
    
    33% {
      height: 18px;
    }
    
    34% {
      height: 37px;
    }
    
    51% {
      height: 37px;
    }
    
    52% {
      height: 55px;
    }
    
    69% {
      height: 55px;
    }
    
    70% {
      height: 74px;
    }
    
    87% {
      height: 74px;
    }
    
    88% {
      height: 92px;
    }
    
    88% {
      height: 92px;
    }
    
    99% {
      height: 92px;
    }
    
    100% {
      height: 110px;
    }
  }
</style>
<template>
    <v-card style="position:relative" class="elevation-0">
        <div  class="window" id="terminalwrap"  style="overflow-y:scroll;position:absolute;bottom:4rem;top:0;width:100%;right:0;left:0">
            <div class="terminal" id="terminal" style=";padding-top:0.5rem;padding-bottom:0.5rem">
                <p class="log">
                    <span>
                    Waiting for connection...<br />
                    </span>
                </p>
            </div>
        </div>
        <v-card-actions style="position:absolute;bottom:0;height:4rem;width:100%">
            <v-btn color="#39a9dc" dark small v-on:click="connect">Connect</v-btn>
            <p v-if="err" color="red">{{err}}</p>
            <v-spacer></v-spacer>
            <!-- <v-text-field v-model="data" placeholder="Put here text..." style="margin-top:1.7rem;padding:1rem"></v-text-field>
            <v-btn color="#39a9dc" dark small v-on:click="sendData">send</v-btn> -->
            <v-btn color="#39a9dc" dark small v-on:click="clear">Clear</v-btn>
        </v-card-actions>
    </v-card>
</template>
<script>
import * as webSerial from 'web_serial';
export default {

    mounted(){
    },

    data(){
      return{
        port: null,
        data: null,
        err: null,
      }
    },
    
    methods: {
       async  connect(){
          this.err=null;
          const serialManager = new webSerial.serial.SerialManager();
          const port = await serialManager.requestPorts();
          this.port = port;
          const channelDescriptor = new webSerial
                  .types
                  .ChannelDescriptor(
                      webSerial.types.BaudRate.BR115200,
                      webSerial.types.DataBits.B8,
                      webSerial.types.StopBits.B1,
                      webSerial.types.Parity.NONE,
                      undefined,
                      webSerial.types.Parity.NONE,
                  );
          await port.open(channelDescriptor);
          

          try {
              let i = 0 ;
              while (true) {
                  const { value, done } = await port.reader.read();
                  if (done) {
                      // Allow the serial port to be closed later.
                      port.reader.releaseLock();
                      break;
                  }
                  if (value) {
                      let s = "";
                      value.forEach(b => s+=String.fromCharCode(b))
                      const terminalBox = document.getElementById('terminal');
                      let terminalBoxContent = terminalBox.innerHTML; 
                      terminalBox.innerHTML = (terminalBoxContent + s).replaceAll("\n\r","<br>").replaceAll("\r\n","<br>");
                  }
              }
          } catch (error) {
              console.err(error);
              this.err= error.msg;
          }
      },

      async disconnect(){
          await this.port.disconnect();
      },

      async sendData(){
          const buf = Uint8Array.from(this.data+"\r\n");
          await this.port.writer.write(buf);
          this.data = "";
      },

      
      async clear(){
          const terminalBox = document.getElementById('terminal');
          terminalBox.innerHTML = "";
      }
    },
}
</script>
